import { get, deleteOp, post, del } from '@/utils/request'

const downloadFile = url => get(url, {}, { responseType: 'arraybuffer' });

// 获取字典项
const getDictionary = type => get(`/admin/dict/type/${type}`)

// 获取区域树
const getAreaTree = params => get('/admin/sysArea/tree', params)

// 获取个人信息
const getUserInfo = () => get('/admin/user/info')

// 获取菜单
const getMenu = params => get('/admin/menu', params)

// 退出登录
const logoutApi = () => get('/auth/logout')

// 下载文件
const requestFile = (url) => get(url, {}, { responseType: 'blob' });

// 专家标签树（4个大类，含多级子标签）- 走全局 baseURL 与 devServer 代理
const getExpertTagTree = (params) => get(`/expert-tag/tree`, params)
// 第三方用户查询 GET /api/expert-info/third-party/query-user
const queryThirdPartyUser = (params) => get(`/expert-info/third-party/query-user`, params)
// 第三方用户纳入专家库 POST /api/expert-info/{id}/third-party/grant
const grantExpertInfoThirdParty = (id) => post(`/expert-info/${id}/third-party/grant`)
// 第三方用户详情 GET /api/expert-info/third-party/user/{id}
export const getThirdPartyUserDetail = (id) => get(`/expert-info/third-party/user/${id}`)
// 新增专家标签（payload 不带 id）POST /api/expert-tag
const createExpertTag = (data) => post(`/expert-tag`, data)
// 编辑专家标签（payload 带 id）POST /api/expert-tag
const updateExpertTag = (data) => post(`/expert-tag`, data)
// 删除专家标签 POST /api-swyxxjs/expert-tag/delete/{id}
const deleteExpertTag = (id) => post(`/expert-tag/delete/${id}`)

// 专家信息管理 - 走全局 baseURL 与 devServer 代理
// 专家信息分页查询 GET /api/expert-info/page
const getExpertInfoPage = (params) => get(`/expert-info/page`, params)
// 新增专家信息 POST /api/expert-info
const createExpertInfo = (data) => post(`/expert-info`, data)
// 专家详情 GET /api/expert-info/{id}
const getExpertInfoDetail = (id) => get(`/expert-info/${id}`)
// 删除专家信息 POST /api/expert-info/delete/{id}
const deleteExpertInfo = (id) => post(`/expert-info/delete/${id}`)
// 更新专家信息 POST /api/expert-info
const updateExpertInfo = (data) => post(`/expert-info`, data)
// 更新专家状态 POST /api/expert-info/{id}/status?status=0|1
const updateExpertInfoStatus = (id, status) => post(`/expert-info/${id}/status`, null, { params: { status } })
// 下载导入模板 GET /api/expert-info/template
const downloadExpertInfoTemplate = () => get(`/expert-info/template`, {}, { responseType: 'blob' })
// 批量导入专家信息 POST /api/expert-info/import（multipart/form-data）
const importExpertInfo = (formData, config = {}) => post(`/expert-info/import`, formData, { params: { creator: '测试帐号' }, ...config })
// 导出专家信息 POST /api/expert-info/export（返回二进制流）
const exportExpertInfo = (data) => post(`/expert-info/export`, data, { responseType: 'blob' })
// 获取新增暂存最新数据 GET /api/expert-info/draft/new/latest
const getNewDraftLatest = (creator) => get(`/expert-info/draft/new/latest`, { creator })
// 获取编辑暂存最新数据 GET /api/expert-info/draft/latest
const getDraftLatest = (sourceExpertId) => get(`/expert-info/draft/latest`, { sourceExpertId })
// 保存暂存 POST /api/expert-info/draft
const saveExpertDraft = (data) => post(`/expert-info/draft`, data)

export {
  downloadFile,
  getDictionary,
  getAreaTree,
  getUserInfo,
  getMenu,
  logoutApi,
  requestFile,
  getExpertTagTree,
  queryThirdPartyUser,
  grantExpertInfoThirdParty,
  createExpertTag,
  updateExpertTag,
  deleteExpertTag,
  getExpertInfoPage,
  createExpertInfo,
  getExpertInfoDetail,
  deleteExpertInfo,
  updateExpertInfo,
  updateExpertInfoStatus,
  downloadExpertInfoTemplate,
  importExpertInfo,
  exportExpertInfo,
  getNewDraftLatest,
  getDraftLatest,
  saveExpertDraft,
}
